import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { cfAPI } from "../api";
import { createProgressHandler } from "../utils/createProgressHandler";

// Action Types
export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_ERROR = "CONTACT_ERROR";
export const CONTACTS_FETCH = "CONTACTS_FETCH";
export const CONTACT_FETCH = "CONTACT_FETCH";
export const CONTACT_CREATE = "CONTACT_CREATE";
export const CONTACT_EDIT = "CONTACT_EDIT";
export const CONTACT_DELETE = "CONTACT_DELETE";

// Download Action Types for contacts
const CONTACT_DOWNLOAD_START = "CONTACT_DOWNLOAD_START";
const CONTACT_DOWNLOAD_UPDATE = "CONTACT_DOWNLOAD_UPDATE";
const CONTACT_DOWNLOAD_FINISH = "CONTACT_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/contacts";

// Reusable action types object for consistency
const actionTypes = {
  fetches: {
    request: CONTACT_REQUEST,
    success: CONTACTS_FETCH,
    error: CONTACT_ERROR,
  },
  fetch: {
    request: CONTACT_REQUEST,
    success: CONTACT_FETCH,
    error: CONTACT_ERROR,
  },
  create: {
    request: CONTACT_REQUEST,
    success: CONTACT_CREATE,
    error: CONTACT_ERROR,
  },
  edit: {
    request: CONTACT_REQUEST,
    success: CONTACT_EDIT,
    error: CONTACT_ERROR,
  },
  delete: {
    request: CONTACT_REQUEST,
    success: CONTACT_DELETE,
    error: CONTACT_ERROR,
  },
  download: {
    request: CONTACT_REQUEST,
    start: CONTACT_DOWNLOAD_START,
    update: CONTACT_DOWNLOAD_UPDATE,
    finish: CONTACT_DOWNLOAD_FINISH,
    success: CONTACTS_FETCH,
    error: CONTACT_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  contacts: [],
  contact: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// Actions using the new handlers

export const FetchContacts = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const FetchContact = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetch,
    null // No toast for a fetch
  );
};

export const CreateContact = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, values),
    actionTypes.create,
    "Message Created"
  );
};

export const EditContact = (value) => async (dispatch) => {
  const route =
    value.metadata.messageRead === true ? "markAsRead" : "markAsUnRead";

  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${value.id}/${route}`),
    actionTypes.edit,
    "Contact Updated" // Adding a success message for consistency
  );
};

export const DeleteContact = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "Message Deleted"
  );
};

// Reducer with toasts removed and state logic updated
export const ContactReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONTACT_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case CONTACT_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case CONTACT_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };
    case CONTACT_REQUEST:
      return { ...state, loading: true };
    case CONTACTS_FETCH:
      return { ...state, loading: false, error: "", contacts: action.payload };
    case CONTACT_FETCH:
      return { ...state, loading: false, error: "", contact: action.payload };
    case CONTACT_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
      };
    case CONTACT_EDIT:
      const updatedList = state.contacts.map((contact) =>
        contact.id === action.payload.id ? action.payload : contact
      );
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        contacts: updatedList,
      };
    case CONTACT_DELETE:
      const newList = state.contacts.filter((s) => s.id !== action.payload.id);
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        contacts: newList,
      };
    case CONTACT_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
